// Schema for a single time slot inside an opening-hours rule.
export const _openingHoursSlotClass = {
  days: {
    type: 'array',
    title: 'Päivät',
    items: {
      type: 'number',
      oneOf: [
        { const: 1, title: 'Maanantai' },
        { const: 2, title: 'Tiistai' },
        { const: 3, title: 'Keskiviikko' },
        { const: 4, title: 'Torstai' },
        { const: 5, title: 'Perjantai' },
        { const: 6, title: 'Lauantai' },
        { const: 7, title: 'Sunnuntai' },
      ],
    },
    uniqueItems: true,
  },
  starttime: {
    type: 'string',
    title: 'Alkuaika',
  },
  endtime: {
    type: 'string',
    title: 'Loppuaika',
  },
}

export const _openingHoursSlotUiSchema = {
  days: {
    'ui:widget': 'checkboxes',
  },
  starttime: {
    'ui:widget': 'timeWidget',
  },
  endtime: {
    'ui:widget': 'timeWidget',
  },
}

// Schema for the wrapping rule.
export const _openingHoursRuleClass = {
  name: { type: 'string', title: 'Aukioloajan nimi' },
  active: { type: 'boolean', title: 'Käytössä' },
  priority: { type: 'number', title: 'Prioriteetti' },
  validstart: { type: 'string', format: 'date', title: 'Alkupäivä' },
  validend: { type: 'string', format: 'date', title: 'Loppupäivä' },
  closed: { type: 'boolean', title: 'Suljettu', default: false },
  message: { type: 'string', title: 'Asiakkaalle näytettävä viesti' },
  slots: {
    type: 'array',
    title: 'Aukioloajat',
    items: {
      type: 'object',
      required: ['days'],
      properties: _openingHoursSlotClass,
    },
  },
}

export const _openingHoursRuleUiSchema = {
  priority: {
    'ui:help': 'Pienempi numero on korkeampi prioriteetti',
  },
  validstart: {
    'ui:help': 'Jätä tyhjäksi jos sääntö on aina voimassa',
  },
  validend: {
    'ui:help': 'Jätä tyhjäksi jos sääntö on aina voimassa',
  },
  closed: {
    'ui:help': 'Merkitse rasti, jos tämä sääntö sulkee venuen kokonaan päivinä, joina se on voimassa',
  },
  message: {
    'ui:widget': 'textarea',
    'ui:help': 'Näytetään asiakkaalle, kun hän yrittää varata aikaa suljetulla jaksolla. Jätä tyhjäksi jos viestiä ei tarvita.',
  },
  slots: {
    'ui:help': 'Suljetulla säännöllä aukioloaikoja ei tarvitse asettaa: tyhjä lista sulkee kaikki viikonpäivät voimassaolojakson aikana. Jos haluat sulkea vain tietyt viikonpäivät (esim. sunnuntaisin talvella), valitse viikonpäivät — alkamis- ja päättymisaikoja ei käytetä suljetuissa säännöissä.',
    items: _openingHoursSlotUiSchema,
  },
}
